import Vue from 'vue'
import Router from 'vue-router'
import {routerView} from './mainRouter'

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error=> error)
}

Vue.use(Router)

let RouteList = [
    {path: '/404', component: () => import('~/views/404'), hidden: true},
    {
        path: '/',
        component: resolve => require(['~/views/Layout/App.vue'], resolve),
        meta: {
            title: '首页',
            keepAlive: false,
        },
        children: routerView
    },
    {
        path: '/login',
        name: 'Login',
        meta: {
            title: '后台登录',
            keepAlive: false
        },
        components: {
            blank: resolve => require(['~/views/Login/Login.vue'], resolve),
        }
    },
	
	{
        path: '/restPassword',
        name: 'RestPassword',
        meta: {
            title: '修改密码',
            keepAlive: false
        },
        components: {
            blank: resolve => require(['~/views/Login/RestPassword.vue'], resolve),
        }
    },
    {
        path: '/pud',
        name: 'PasswordUser',
        meta: {
            title: '修改密码',
            keepAlive: false
        },
        components: {
            blank: resolve => require(['~/views/Login/PasswordUser.vue'], resolve),
        }
    },
	
    {path: '*', redirect: '/404', hidden: true}

]
const createRouter = () => new Router({
     mode: 'history', // require service support
   scrollBehavior: () => ({ y: 0 }),
   routes: RouteList
 })

 const router = createRouter()

//  router.afterEach((to, from) => {
//      console.log(to)
//  })
router.beforeEach((to, from, next) => {
    //console.log(to)
    if(to.name && to.path !== '/' && to.path !== '/login' && to.path !== '/404'){
        
        let cfg
        cfg = (cfg = JSON.parse(sessionStorage.getItem("byomsquery"))) ? cfg : {}
        cfg[to.path] = Object.assign({}, to.query) 
        sessionStorage.setItem("byomsquery", JSON.stringify(cfg))
    }
    
    next()
})

 export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher // reset router
  }
  
  export default router
//export default new Router({routes: RouteList, mode: 'history'})





// WEBPACK FOOTER //
// ./src/router/index.js